import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import Logo from "../assets/tanda.png";
import "./Styles.css";
import Logo1 from "../Images/LogoT1.png";
import { NavLink } from "react-router-dom";

const MainHeader = () => {
  const [isMenu, setIsMenu] = useState(false);

  // const showMenu = () => {
  //   setIsMenu(!isMenu);
  // };

  // const myMenu = document.getElementById("menu");

  // myMenu.onclick = (
  //   e // JS event delegation
  // ) => {
  //   if (e.target.tagName.toLowerCase() != "a") return; // only
  //   e.preventDefault;
  //   let LI = e.target.parentElement;

  //   if (!LI.classList.contains("active")) {
  //     myMenu.querySelector("li.active").classList.remove("active");
  //   }
  //   LI.classList.add("active");
  // };

  return (
    <div className="fixed z-50 bg-[#eff2f3] shadow-md h-20 md:h-28 px-0">
      {/* Desktop */}
      <div className="hidden md:flex w-screen h-full">
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center ml-4 shrink-0">
            <img src={Logo1} className="h-20 lg:h-24 w-auto object-contain" />
            <div className="text-[#243265] ml-2 flex flex-col leading-none whitespace-nowrap">
              <p className="-mb-0 text-2xl lg:text-3xl font-extrabold font-serif">TANDA</p>
              <p className="font-serif text-base lg:text-lg">RUBBER WORKS</p>
            </div>
          </div>
          <div className="flex-1 md:mr-8 lg:mr-14 md:mt-5 text-lg lg:text-xl font-serif">
            <ul className="hidden md:flex justify-end space-x-4 lg:space-x-10 px-3 mt-6 mr-2 lg:mr-5 uppercase whitespace-nowrap">
              <li className=" no-underline hover:underline decoration-slate-50 font-normal cursor-pointer">
                <NavLink
                  to={`/`}
                  className={({ isActive }) =>
                    `px-3 py-1 rounded-md transition-colors ${
                      isActive
                        ? "bg-blue-100 text-[#243265]"
                        : "text-[#243265] hover:bg-blue-50"
                    }`
                  }
                >
                  Home
                </NavLink>
              </li>
              <li className="no-underline hover:underline decoration-slate-50   font-normal cursor-pointer">
                <NavLink
                  to={`/about-us`}
                  className={({ isActive }) =>
                    `px-3 py-1 rounded-md transition-colors ${
                      isActive
                        ? "bg-blue-100 text-[#243265]"
                        : "text-[#243265] hover:bg-blue-50"
                    }`
                  }
                >
                  About us
                </NavLink>
              </li>
              <li className="no-underline hover:underline decoration-slate-50   font-normal cursor-pointer">
                <NavLink
                  to="/services"
                  className={({ isActive }) =>
                    `px-3 py-1 rounded-md transition-colors ${
                      isActive
                        ? "bg-blue-100 text-[#243265]"
                        : "text-[#243265] hover:bg-blue-50"
                    }`
                  }
                >
                  SERVICES
                </NavLink>
              </li>

              {/* 
          <li className="no-underline hover:underline  font-semibold cursor-pointer">
            <NavLink  to="/services" style={{ color: "black" }}>
            SERVICE SUPPORT
            </NavLink>
          </li>
          <li className="no-underline hover:underline  font-semibold cursor-pointer">
            <NavLink  to="/media" style={{ color: "black" }}>
              Media
            </NavLink>
          </li> */}
              <li className="no-underline hover:underline decoration-slate-50   font-normal cursor-pointer">
                <NavLink
                  to="/contact-us"
                  className={({ isActive }) =>
                    `px-3 py-1 rounded-md transition-colors ${
                      isActive
                        ? "bg-blue-100 text-[#243265]"
                        : "text-[#243265] hover:bg-blue-50"
                    }`
                  }
                >
                  Contact Us
                </NavLink>
              </li>
              <li className="no-underline hover:underline decoration-slate-50   font-normal cursor-pointer">
                <NavLink
                  to="/log-in"
                  className={({ isActive }) =>
                    `px-3 py-1 rounded-md transition-colors ${
                      isActive
                        ? "bg-blue-100 text-[#243265]"
                        : "text-[#243265] hover:bg-blue-50"
                    }`
                  }
                >
                  Log In
                </NavLink>
              </li>
            </ul>
          </div>
          {/* <a
            href="https://wa.me/+918049720731"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center "
          >
            <div className="items-center rounded-l-3xl  bg-green-500 p-3  font-bold text-white md:h-9 h-10 flex	">
              <FaWhatsapp className="mx-2 text-3xl" />{" "}
              <span className="text-xl">+91 6364376522</span>
            </div>
            <div className="items-center  bg-blue-500   font-bold text-white md:h-9 h-10 flex pr-6	">
              <FiPhoneCall className="mx-2 text-2xl" />
              <span className="text-xl">+91 8049720731</span>
            </div>
          </a> */}
        </div>
      </div>

      {/* mobile */}
      <div className=" md:hidden h-20">
        <div className="flex w-screen px-3 py-2 h-full items-center justify-between ">
          <div className="flex items-center">
            <img src={Logo1} className="h-24 w-24 object-contain" />
            <div className="text-[#243265] ml-3">
              <p className="-mb-0 text-lg font-extrabold font-serif leading-tight">
                TANDA RUBBER WORKS
              </p>
            </div>
          </div>
          <button
            className="block md:hidden py-2 px-2 mx-1 rounded focus:outline-none hover:bg-gray-900 group"
            onClick={() => setIsMenu(!isMenu)}
          >
            <div className="w-5 h-1 bg-[#243265] mb-1"></div>
            <div className="w-5 h-1 bg-[#243265] mb-1"></div>
            <div className="w-5 h-1 bg-[#243265]"></div>
          </button>
          {isMenu && (
            <div
              className="absolute top-24 w-full right-0
      group-focus:right-0 group-focus:opacity-100 transition-all duration-300 bg-gray-800  
       shadow-lg shadow-black-500/110"
            >
              <ul className="flex flex-col w-full text-base cursor-pointer pt-1 text-left uppercase">
                <li
                  className=" ml-2 py-2 transition ease-in-out delay-50 font-semibold  hover:-translate-y-4 hover:scale-10
                hover:bg-blue-400  duration-300 ..."
                >
                  <NavLink
                    onClick={() => setIsMenu(false)}
                    to={`/`}
                    className={({ isActive }) =>
                      `block px-3 py-1 rounded-md transition-colors ${
                        isActive
                          ? "bg-blue-200 text-[#243265]"
                          : "text-white hover:bg-blue-500"
                      }`
                    }
                  >
                    Home
                  </NavLink>
                </li>
                <li className="hover:bg-gray-200 ml-2 py-2 transition ease-in-out delay-50 font-semibold  hover:-translate-y-1 hover:scale-10 duration-300 ...">
                  <NavLink
                    onClick={() => setIsMenu(false)}
                    to={`/about-us`}
                    className={({ isActive }) =>
                      `block px-3 py-1 rounded-md transition-colors ${
                        isActive
                          ? "bg-blue-200 text-[#243265]"
                          : "text-white hover:bg-blue-500"
                      }`
                    }
                  >
                    About us
                  </NavLink>
                </li>
                <li className="hover:bg-gray-200 ml-2 py-2 transition ease-in-out delay-50 font-semibold  hover:-translate-y-1 hover:scale-10 duration-300 ...">
                  <NavLink
                    onClick={() => setIsMenu(false)}
                    to="/services"
                    className={({ isActive }) =>
                      `block px-3 py-1 rounded-md transition-colors ${
                        isActive
                          ? "bg-blue-200 text-[#243265]"
                          : "text-white hover:bg-blue-500"
                      }`
                    }
                  >
                    SERVICES
                  </NavLink>
                </li>
                <li className="hover:bg-gray-200 ml-2 py-2 transition ease-in-out delay-50 font-semibold  hover:-translate-y-1 hover:scale-10 duration-300 ...">
                  <NavLink
                    onClick={() => setIsMenu(false)}
                    to="/contact-us"
                    className={({ isActive }) =>
                      `block px-3 py-1 rounded-md transition-colors ${
                        isActive
                          ? "bg-blue-200 text-[#243265]"
                          : "text-white hover:bg-blue-500"
                      }`
                    }
                  >
                    Contact Us
                  </NavLink>
                </li>
                  <li className="hover:bg-gray-200 ml-2 py-2 transition ease-in-out delay-50 font-semibold  hover:-translate-y-1 hover:scale-10 duration-300 ...">
                  <NavLink
                    onClick={() => setIsMenu(false)}
                    to="/log-in"
                    className={({ isActive }) =>
                      `block px-3 py-1 rounded-md transition-colors ${
                        isActive
                          ? "bg-blue-200 text-[#243265]"
                          : "text-white hover:bg-blue-500"
                      }`
                    }
                  >
                    Log In
                  </NavLink>
                </li>
              </ul>
            </div>
          )}
        </div>
        {/* <div>
          <a
            href="https://wa.me/+918049720731"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="items-center  bg-green-500 p-3 font-bold text-white h-10 flex	">
              <FaWhatsapp size={20} /> &nbsp; +91 6364376522
            </div>
          </a>

          <div className="items-center  bg-blue-500  p-3 font-bold text-white h-10 flex	">
            <FiPhoneCall size={17} /> &nbsp; +91 8049720731
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default MainHeader;
